import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Paper, Typography } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function NotFoundTemplate({ active = null, body = null }) {
  const navigate = useNavigate();

  return (
    <Box display='flex' justifyContent='center' alignItems='center' minHeight='80vh'>
      <Paper
        elevation={2}
        sx={{
          p: 6,
          width: 520,
          textAlign: 'center',
          borderRadius: 2,
        }}
      >
        <ErrorOutline color='warning' sx={{ fontSize: 72, mb: 2 }} />

        <Typography variant='h5' fontWeight={700} gutterBottom>
          Page Unavailable
        </Typography>

        <Typography color='text.secondary' mb={4}>
          {body ??
            'This page cannot be opened because it was not found or it is no longer available'}
        </Typography>

        {active && (
          <Button variant='contained' onClick={() => navigate(-1)}>
            Go Back
          </Button>
        )}
      </Paper>
    </Box>
  );
}

NotFoundTemplate.propTypes = {
  active: PropTypes.bool,
  body: PropTypes.string,
};
